export default __webpack_public_path__ + "static/media/AdobeStock_445203368.c302be56.jpg";